import { Component, ElementRef, OnInit, inject, input } from '@angular/core';
import { DxLoadIndicatorModule } from 'devextreme-angular';

@Component({
    selector: 'app-load-indicator',
    templateUrl: './load-indicator.component.html',
    styleUrl: './load-indicator.component.scss',
    imports: [DxLoadIndicatorModule]
})
export class LoadIndicatorComponent implements OnInit {

    private readonly el = inject(ElementRef);

    readonly $size = input<number>(55, { alias: 'size' });
    readonly $showBackground = input<boolean>(true, { alias: 'showBackground' });
    readonly $opacity = input<number>(0.4, { alias: 'opacity' });
    readonly $color = input<'warn' | 'accent'>('warn', { alias: 'color' });
    readonly $align = input<'start' | 'middle' | 'end' | undefined>('start', { alias: 'align' });

    get background(): string | null {
        return this.$showBackground() ? null : 'transparent';
    }

    ngOnInit() {
        (this.el.nativeElement as HTMLElement)!.parentElement!.style.position = 'relative';

    }

}
